import { ProductRegistrationService } from './../../../data/services/product-registration'
import { ProductRegistration } from './../../../data/models/product-registration'
import { ProductRegistrationPresenter } from '../../../data/presenters'
import { IDataServiceConfig, ModelRepository } from './../../../model-repository'

export const ProductRegistrationConfig: IDataServiceConfig<ProductRegistration> = {
  service: ProductRegistrationService,
  deps: [ModelRepository],
  endpoint: 'orders/product_registrations?filter[user-id]=:user_id',
  model: ProductRegistration,
  presenter: ProductRegistrationPresenter,
  backend: 'uncached',
  mappings: [{
    jsonType: 'product-registrations',
    classType: 'ProductRegistration',
    propertyMapping: {
      activeAt: {
        transform: {
          toModel: (jsonValue) => new Date(jsonValue),
          toJson: (modelValue) => modelValue.toISOString()
        }
      },
      inactiveAt: {
        transform: {
          toModel: (jsonValue) => new Date(jsonValue),
          toJson: (modelValue) => modelValue.toISOString()
        }
      },
      createdAt: {
        transform: {
          toModel: (jsonValue) => new Date(jsonValue),
          toJson: (modelValue) => modelValue.toISOString()
        }
      }
    }
  }]
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/config/services/data/product-registration.config.ts